export interface OcvConfig {
  appId: number;
  serviceTreeId: string;
  centroHostName: string;
  featureArea: string;
}

const ocvConfigs: Record<string, OcvConfig> = {
  local: {
    appId: 50495,
    serviceTreeId: "2d971030-0caf-451f-a5b2-fe7e5c36dfe3",
    centroHostName: "DiningService",
    featureArea: "Microsoft Dining",
  },
  dev: {
    appId: 50495,
    serviceTreeId: "2d971030-0caf-451f-a5b2-fe7e5c36dfe3",
    centroHostName: "DiningService",
    featureArea: "Microsoft Dining",
  },
  ppe: {
    appId: 50495,
    serviceTreeId: "2d971030-0caf-451f-a5b2-fe7e5c36dfe3",
    centroHostName: "DiningService",
    featureArea: "Microsoft Dining",
  },
  prod: {
    appId: 3072,
    serviceTreeId: "2d971030-0caf-451f-a5b2-fe7e5c36dfe3",
    centroHostName: "DiningService",
    featureArea: "Microsoft Dining",
  },
};

export const getOcvConfig = (): OcvConfig => {
  const env = process.env.APP_ENV || "dev";
  return ocvConfigs[env] || ocvConfigs.dev;
};
